import React from 'react'
import { pdf, Document, Text, Page, View, Image } from '@react-pdf/renderer'
import reportStyles from './PDFReportStyles';    

const DevMilestonePage = (params) => {
   
  const entity = params.entity;
  const reportParams = params.params;  

  return (

<Page size="A4" style={reportStyles.page}>
    <View style={reportStyles.HeaderContainer}>
        <Image src={process.env.PUBLIC_URL + '/images/DevMilestone.jpg'}  style={reportStyles.headerImage}/>                                                 
        <Text style={reportStyles.PageTitle}>Development Milestones</Text>                    
    </View>                            
    <View style={reportStyles.CenterContainerStart}>    
        <View style={reportStyles.table}>
            <View style={reportStyles.rowPageSubHeader}>
                <View style={reportStyles.cell50NBLeft}>
                    <Text style={reportStyles.PageSubTitle}>Milestones</Text>
                </View>
            </View>                               
            <View style={reportStyles.row}>
                <View style={reportStyles.cell60NB}>
                    <Text style={reportStyles.PageText}>Physical Development:</Text>
                    <Text style={reportStyles.description}>Description:</Text>
                </View>
                <View style={reportStyles.cell10}>
                    <Image src={process.env.PUBLIC_URL + '/images/GreenRadioBtn.png'} style={reportStyles.image40x40Cell}/> 
                </View>
                <View style={reportStyles.cell10}>
                    <Image src={process.env.PUBLIC_URL + '/images/GreenRadioBtn.png'} style={reportStyles.image40x40Cell}/> 
                </View>
                <View style={reportStyles.cell10}>
                    <Image src={process.env.PUBLIC_URL + '/images/GreenRadioBtn.png'} style={reportStyles.image40x40Cell}/> 
                </View>
                <View style={reportStyles.cell10}>
                    <Image src={process.env.PUBLIC_URL + '/images/GreenRadioBtn.png'} style={reportStyles.image40x40Cell}/> 
                </View>
            </View>
            <View style={reportStyles.row}>
                <View style={reportStyles.cell60NB}>
                    <Text style={reportStyles.PageText}>Congitive Skils:</Text>
                    <Text style={reportStyles.description}>Description:</Text>
                </View>
                <View style={reportStyles.cell10}>
                    <Image src={process.env.PUBLIC_URL + '/images/GreenRadioBtn.png'} style={reportStyles.image40x40Cell}/> 
                </View>
                <View style={reportStyles.cell10}>
                    <Image src={process.env.PUBLIC_URL + '/images/GreenRadioBtn.png'} style={reportStyles.image40x40Cell}/> 
                </View>
                <View style={reportStyles.cell10}>
                    <Image src={process.env.PUBLIC_URL + '/images/GreenRadioBtn.png'} style={reportStyles.image40x40Cell}/> 
                </View>
                <View style={reportStyles.cell10}>
                    <Image src={process.env.PUBLIC_URL + '/images/GreenRadioBtn.png'} style={reportStyles.image40x40Cell}/> 
                </View>
            </View>
            <View style={reportStyles.row}>
                <View style={reportStyles.cell60NB}>
                    <Text style={reportStyles.PageText}>Social and Emotional:</Text>
                    <Text style={reportStyles.description}>Description:</Text>
                </View>
                <View style={reportStyles.cell10}>
                    <Image src={process.env.PUBLIC_URL + '/images/GreenRadioBtn.png'} style={reportStyles.image40x40Cell}/> 
                </View>
                <View style={reportStyles.cell10}>
                    <Image src={process.env.PUBLIC_URL + '/images/GreenRadioBtn.png'} style={reportStyles.image40x40Cell}/> 
                </View>
                <View style={reportStyles.cell10}>
                    <Image src={process.env.PUBLIC_URL + '/images/GreenRadioBtn.png'} style={reportStyles.image40x40Cell}/> 
                </View>
                <View style={reportStyles.cell10}>
                    <Image src={process.env.PUBLIC_URL + '/images/GreenRadioBtn.png'} style={reportStyles.image40x40Cell}/> 
                </View>
            </View>
            <View style={reportStyles.row}>
                <View style={reportStyles.cell60NB}>
                    <Text style={reportStyles.PageText}>Language and Communication:</Text>
                    <Text style={reportStyles.description}>Description:</Text>
                </View>
                <View style={reportStyles.cell10}>
                    <Image src={process.env.PUBLIC_URL + '/images/GreenRadioBtn.png'} style={reportStyles.image40x40Cell}/> 
                </View>
                <View style={reportStyles.cell10}>
                    <Image src={process.env.PUBLIC_URL + '/images/GreenRadioBtn.png'} style={reportStyles.image40x40Cell}/> 
                </View>
                <View style={reportStyles.cell10}>
                    <Image src={process.env.PUBLIC_URL + '/images/GreenRadioBtn.png'} style={reportStyles.image40x40Cell}/> 
                </View>
                <View style={reportStyles.cell10}>
                    <Image src={process.env.PUBLIC_URL + '/images/GreenRadioBtn.png'} style={reportStyles.image40x40Cell}/> 
                </View>
            </View>
            <View style={reportStyles.row}>
                <View style={reportStyles.cell50NB}>
                    <Text  style={reportStyles.PageSubTitle}>Concern(s):</Text>
                    <Image src={process.env.PUBLIC_URL + '/images/Red75Ind.png'} style={reportStyles.imageIndCell}/> 
                </View>
                <View style={reportStyles.cell50NB}>
                    <Text style={reportStyles.PageText}>Need for consultation</Text>
                    <Text style={reportStyles.description}>Recommended*</Text>
                    <Image src={process.env.PUBLIC_URL + '/images/RedCheck.png'} style={reportStyles.image33Cell}/> 
                </View>
            </View> 
        </View>                                   
    </View>                            
    <View style={reportStyles.FooterContainerSmall}>
        <Text style={reportStyles.footer}>*Indicates if it is apparent that a consultation with a Child Nutritionist within a short period of time
            could be useful in improving the physical wellbeing of the child. This is calculated based on the
            answers received in the scan and peer comparisons.

            # Please note that these findings are for informational and educational purposes only. If you feel that
            there might be something wrong with your child's health, please consult a pediatrician immediately.
        </Text>
    </View>                            
    </Page>  


  )          
}
  
export default DevMilestonePage